var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basics-card-tips"},[_c('div',{staticClass:"c-name"},[_c('div',{staticClass:"n-p"},[_vm._v(" 缺考 "),_c('br'),_vm._v("标记 ")])]),_c('div',{staticClass:"c-cont"},[_c('span',{staticClass:"c-t"},[_vm._v("缺考")]),_c('span',{staticClass:"c-t c-b c-b0"})])])
}]

export { render, staticRenderFns }